// ------------------------------------------------------------------------------
// <auto-generated>
// This code was generated by the @augloop/code-gen tool.
// Source: https://dev.azure.com/office/ISS/_git/augloop-workflows?path=%2Ftypes%2Fsmart-compose%2Fsrc%2Fsignals.ts
// Changes to this file may cause incorrect behavior and will be lost upon regeneration.
// </auto-generated>
// ------------------------------------------------------------------------------

import { CustomSettings, ISmartComposeSignal } from '../signals';
import { Envelope } from '../smart-compose-types';
import { ISchemaObject, SchemaObject, SchemaObjectHeader } from '@augloop/types-core';

export class SmartComposeSignal implements ISmartComposeSignal {
    public text: string;
    public salutationAppropriate: number;
    public suggestionAccepted: number;
    public context?: string;
    public isPartial?: boolean;
    public envelope?: Envelope;
    public customSettings?: CustomSettings;
    public targetObject?: ISchemaObject;
    public timestamp?: number;
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: ISmartComposeSignal) {
        SchemaObject.assign(SmartComposeSignal, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_SmartCompose_SmartComposeSignal';
    }
    public static getBaseTypes(): string[] {
        return ['AugLoop_Signals_Signal'];
    }
    public static readonly H_ = { T_: SmartComposeSignal.getTypeName(), B_: SmartComposeSignal.getBaseTypes() };
}

